/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MessageFileRepresentationFromJSON, MessageFileRepresentationToJSON, MessageStatusFromJSON, MessageStatusToJSON, } from './';
export function MessageRepresentationFromJSON(json) {
    return MessageRepresentationFromJSONTyped(json, false);
}
export function MessageRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        messageThreadId: json['messageThreadId'],
        order: json['order'],
        creatorId: json['creatorId'],
        content: json['content'],
        creationTime: new Date(json['creationTime']),
        status: MessageStatusFromJSON(json['status']),
        files: !exists(json, 'files')
            ? undefined
            : json['files'].map(MessageFileRepresentationFromJSON),
    };
}
export function MessageRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        messageThreadId: value.messageThreadId,
        order: value.order,
        creatorId: value.creatorId,
        content: value.content,
        creationTime: value.creationTime.toISOString(),
        status: MessageStatusToJSON(value.status),
        files: value.files === undefined ? undefined : value.files.map(MessageFileRepresentationToJSON),
    };
}
